var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "perfil", attrs: { fluid: "" } },
    [
      _c("div", { staticClass: "data" }, [
        _c("div", [_c("span", [_vm._v(_vm._s(_vm.$hoje))])]),
        _c(
          "div",
          [
            _c("v-img", {
              staticClass: "imagem_calendar",
              attrs: { src: require("../../../assets/icons/calendar_icon.svg") }
            })
          ],
          1
        )
      ]),
      _c("router-view")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }